import styled from 'styled-components/macro'
import Box from 'components/shared/Box'
import { Color } from 'styles/types'

interface LegendProps {
    color: Color
}

export const StyledLegend = styled(Box)<LegendProps>`
    position: relative;
    min-width: 12px;
    min-height: 12px;
    margin-top: 2px;
    border-radius: 2px;
    background: ${({ theme, color }) => theme.colors[color]};
    img {
        position: absolute;
        left: -14px;
        top: -8px;
    }
`
